<template>
  <div>
    <b-modal ref="HistoryPacketModal" size="lg">
      <div slot="modal-title">
        <div class="d-flex">
          <h5 class="modal-title">{{$t('modal_dialogs.history_of_packet')}} - {{packageNr}}</h5>
        </div>
      </div>
      <div>
        <b-row>
          <b-col>
            <ag-grid-vue class="ag-theme-balham grid" :gridOptions="gridOptions"
                         :rowData="rowData" :columnDefs="columns"
            >
            </ag-grid-vue>
          </b-col>
        </b-row>
      </div>
      <div slot="modal-footer" class="w-100 text-center">
      </div>
    </b-modal>
  </div>
</template>

<script>
  import { AgGridVue } from 'ag-grid-vue';
  import { addColIdToColumns, handlerResponse } from '@/helpers/commonHelpers';
  import { autoResize, formatNumber, alignCells, LinkCellRenderer } from '@/helpers/renderHelpers';

  export default {
    components: {
      AgGridVue
    },
    data() {
      return {
        packageNr: '',
        packageData: {},
        columns: [],
        rowData: [],
        gridOptions: {
          animateRows: true,
          components: {
            'CreatedMovementLink': LinkCellRenderer('movement_id', '/operation/'),
            'CompletedMovementLink': LinkCellRenderer('progress_movement_id', '/operation/')
          },
          defaultColDef: {
            sortable: true,
            filter: true,
            resizable: true,
            valueFormatter(params) {
              return formatNumber(params.value, null)
            },
            cellStyle(params) {
              return alignCells(params);
            }
          },
          onRowDataChanged() {
            autoResize(this);
          },
          onGridReady() {
            if (!this.rowData.length) {
              this.api.showNoRowsOverlay();
            }
          }
        }
      }
    },
    mounted() {
      this.$root.$on('openHistoryPacketModal', (rowData) => {
        this.packageData = rowData.data;
        this.packageNr = this.packageData.package_nr;
        (async () => {
          const params = {is_vue: true};
          const historyPacketData = await this.$http.get(`woodware/movement_data/${this.packageNr}/detail/`, {params})
            .then(handlerResponse);
          this.columns = addColIdToColumns(historyPacketData.used_columns);
          this.rowData = historyPacketData.data;
          if (this.$refs['HistoryPacketModal']) {
            this.$refs['HistoryPacketModal'].show();
          }
        })();
      });
    },
    beforeDestroy() {
      this.$root.$off('openHistoryPacketModal');
    }
  }
</script>

<style scoped>
  .pdf-icon {
    margin-right: 5px;
  }

  .grid {
    height: 500px;
  }
</style>



// WEBPACK FOOTER //
// src/components/modals/HistoryPacketModal.vue